import React from 'react';

import { NavBannerProps } from '../NavBanner';
import { LOCAL_COLORS } from 'styles/constants';

export const LIMITED_TIME_OFFER_BANNER_CONTENT: NavBannerProps = {
  textColor: LOCAL_COLORS.surfaceDarkBold,
  backgroundColor: LOCAL_COLORS.surfaceOrange,
  iconName: 'gift',
  text: (
    <React.Fragment>
      <strong>Limited Time Offer</strong> for new customers!
    </React.Fragment>
  ),
};
